export const toDisplayValue = (value: any) => {
   if (value == null) return "";

   if (Array.isArray(value)) {
      return value.map(toDisplayValue).filter(Boolean).join(", ");
   }

   if (typeof value === "object") {
      if ("label" in value) return String(value.label ?? "");
      if ("decoratedValue" in value) return String(value.decoratedValue ?? "");
      if ("originalValue" in value) return String(value.originalValue ?? "");
      return "";
   }

   return String(value);
};

export const hasValue = (value: any) => {
   if (value === undefined || value === null) return false;
   if (typeof value === "string") return value.trim().length > 0;
   if (Array.isArray(value)) return value.length > 0;

   if (typeof value === "object") {
      if ("value" in value) return hasValue(value.value);
      if ("originalValue" in value) return hasValue(value.originalValue);
      if ("label" in value) return hasValue(value.label);
      return Object.keys(value).length > 0;
   }
   return true;
};

const isDigitsOnly = (text: string) => /^\d+$/.test(text.trim());

export const convertToNumberIfDigits = (value) => {
   if (typeof value === "string") {
      const trimValue = value.trim();
      return isDigitsOnly(trimValue) ? Number(trimValue) : value;
   }

   if (Array.isArray(value)) {
      return value.map(convertToNumberIfDigits);
   }

   if (value && typeof value === "object") {
      const outValue = {};
      for (const [key, val] of Object.entries(value)) {
         outValue[key] = convertToNumberIfDigits(val);
      }
      return outValue;
   }

   return value;
};
